/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkPriceUpdateRequest } from '../../models/bulk-price-update-request';
import { BulkPriceUpdateResponse } from '../../models/bulk-price-update-response';

export interface BulkPriceUpdate$Params {
      body: BulkPriceUpdateRequest
}

export function bulkPriceUpdate(http: HttpClient, rootUrl: string, params: BulkPriceUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkPriceUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkPriceUpdate.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkPriceUpdateResponse>;
    })
  );
}

bulkPriceUpdate.PATH = '/pricing/bulk-update';
